import { post, put, get, remove } from 'communication/httpClient';
import {
  LOAD_AGE_RESTRICTIONS,
  AGE_RESTRICTIONS_LOADED,
  SYNC_FAILED,
  RESET_AGE_RESTRICTIONS,
  RESET_AGE_RESTRICTION,
  AGE_RESTRICTION_DELETED,
  LOAD_AGE_RESTRICTION,
  AGE_RESTRICTION_LOADED,
  SAVE_AGE_RESTRICTION,
  AGE_RESTRICTIONS_SAVED,
  AGE_RESTRICTION_ADDED,
} from './actionTypes';
import { IGenericObject } from '../../types';

export const initialActionsState = {
  loadAgeRestrictions: () => {},
  resetAgeRestrictions: () => {},
  resetAgeRestriction: () => {},
  deleteAgeRestriction: () => {},
  addAgeRestriction: () => {},
  loadAgeRestriction: (id: string) => {},
  updateAgeRestrictionsSavedValue: () => {},
  ageRestrictionDeleted: (id: string) => {},
  addedAgeRestriction: (rule: IGenericObject) => {}, //TODO create type for rule
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadAgeRestrictions: async () => {
    dispatch({
      type: LOAD_AGE_RESTRICTIONS,
    });
    const { data, error } = await get('/api/age-restrictions');
    if (data) {
      dispatch({
        type: AGE_RESTRICTIONS_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadAgeRestriction: async (id: string) => {
    dispatch({
      type: LOAD_AGE_RESTRICTION,
    });
    const { data, error } = await get('/api/age-restrictions/' + id);

    if (data) {
      dispatch({
        type: AGE_RESTRICTION_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  resetAgeRestrictions: () =>
    dispatch({
      type: RESET_AGE_RESTRICTIONS,
    }),
  resetAgeRestriction: () =>
    dispatch({
      type: RESET_AGE_RESTRICTION,
    }),
  deleteAgeRestriction: async (ruleId: string, callback?: () => void) => {
    const { data, error } = await remove('/api/age-restrictions/' + ruleId);
    if (data || data === '') {
      dispatch({
        type: AGE_RESTRICTION_DELETED,
        payload: ruleId,
      });
      if (callback) {
        callback();
      }
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  addAgeRestriction: async (values: any, id?: string) => {
    dispatch({
      type: SAVE_AGE_RESTRICTION,
    });
    const handler = id ? put : post,
      resourceId = id || '';
    const { data, error } = await handler('/api/age-restrictions/' + resourceId, values);

    if (data || data === '') {
      dispatch({
        type: AGE_RESTRICTIONS_SAVED,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  updateAgeRestrictionsSavedValue: () => {
    dispatch({
      type: AGE_RESTRICTIONS_SAVED,
    });
  },
  ageRestrictionDeleted: (id) => {
    dispatch({
      type: AGE_RESTRICTION_DELETED,
      payload: id,
    });
  },
  addedAgeRestriction: (rule) => {
    dispatch({
      type: AGE_RESTRICTION_ADDED,
      payload: rule,
    });
  },
});
